// extracted by mini-css-extract-plugin
module.exports = {"expected-point-container":"ExpectedOrderPoint_expected-point-container__1AyKt","method-txt":"ExpectedOrderPoint_method-txt__8t5p7","question":"ExpectedOrderPoint_question__1WBcn"};